export const PROJECT_NAME = 'Web Builder';

export const DEFAULT_REGULAR_TYPE = 'REGULAR';

export const UPLOAD_FILE_MAX_SIZE = 20971520;

export const STATUS = {
  ALL: 'all',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
};
export const COLOR_CODE_HEX = [
  '#2196f3', // Blue
  '#ff5722', // Deep Orange
  '#4caf50', // Green
  '#ffeb3b', // Yellow
  '#9c27b0', // Purple
  '#ff9800', // Orange
  '#00bcd4', // Cyan
  '#673ab7', // Deep Purple
  '#e91e63', // Pink
  '#03a9f4', // Light Blue
  '#8bc34a', // Light Green
  '#ffc107', // Amber
  '#009688', // Teal
  '#cddc39', // Lime
  '#ffeb3b', // Yellow
  '#f44336', // Red
  '#9c27b0', // Purple
  '#03a9f4', // Light Blue
  '#009688', // Teal
  '#f44336', // Red
  '#673ab7', // Deep Purple
  '#ff9800', // Orange
  '#4caf50', // Green
  '#2196f3', // Blue
  '#ff5722', // Deep Orange
  '#00bcd4', // Cyan
  '#e91e63', // Pink
  '#8bc34a', // Light Green
  '#ffc107', // Amber
];
export const STATUS_OPTIONS = [
  {
    label: 'Active',
    value: 'ACTIVE',
  },
  {
    label: 'In Active',
    value: 'INACTIVE',
  },
  {
    label: 'Expired',
    value: 'EXPIRED',
  },
];

export const SERVICE_TYPE_VALUES = {
  SMS: 'SMS',
  WHATSAPP: 'WHATSAPP',
  EMAIL: 'EMAIL',
};

export const SERVICE_TYPE_OPTIONS = [
  {
    label: 'SMS',
    value: 'SMS',
  },
  {
    label: 'Whatsapp',
    value: 'WHATSAPP',
  },
  {
    label: 'email',
    value: 'EMAIL',
  },
];

export const DISCOUNT_TYPE = {
  FLAT: 'FLAT',
  PERCENTAGE: 'PERCENTAGE',
};

export const SYMBOLS = {
  RUPEE: '₹',
  PERCENT: '%',
  CURRENCY: 'INR',
};
export const MODULE_CATEGORIES = {
  BRANDING: 'BRANDING',
  ACADEMIC: 'ACADEMIC',
  ADMINISTRATION: 'ADMINISTRATION',
  MANAGEMENT: 'MANAGEMENT',
  COMMUNICATION: 'COMMUNICATION',
  CONFIGURATION: 'CONFIGURATION',
  ENQUIRIES: 'ENQUIRIES',
  INBOX: 'INBOX',
};
export const GENDER_OPTIONS = ['MALE', 'FEMALE'];
export const BANNER_TYPES = {
  HOME_BANNER: 'HOME_BANNER',
  POPUP_BANNER: 'POPUP_BANNER',
  AD_BANNER: 'AD_BANNER',
};

export const IDEA_STATUS = {
  NEW: 'NEW',
  SHORTLIST: 'SHORTLIST',
  SPAM: 'SPAM',
};

export const TABLE_ROW_COUNT = 25;
export const TABLE_ROW_WITH_HIGH_COUNT = 10000;
export const KEY_UNAVAILABLE = 'KEY_UNAVAILABLE';

export const ANIMATION = {
  timeout: 1000,
};

export const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export const USER_RIGHTS_KEYS = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
};

export const POST_CATEGORIES = {
  INSTA_ALERT: 'INSTA_ALERT',
  BLOG: 'BLOG',
  NEWS_FEED: 'NEWS_FEED',
  ASSIGNMENT: 'ASSIGNMENT',
  EVENT: 'EVENT',
  OFFER: 'OFFER',
  NOTICEBOARD: 'NOTICEBOARD',
  POLL: 'POLL',
  TRAVEL: 'TRAVEL',
  FOOD_BLOG: 'FOOD BLOG',
  DESTINATIONS: 'DESTINATIONS',
  ARCHITECTURE_AND_DESIGNS: 'ARCHITECTURE AND DESIGNS',
  DECOR: 'DECOR',
};

export const BLOG_EDITOR_FIELDS = {
  SINGLE_IMAGE: 'singleImage',
  MULTIPLE_IMAGES: 'multipleImages',
  YOUTUBE: 'youtube',
  INSTAGRAM: 'instagram',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  BUTTON: 'button',
};
export const VARIENT_EDITOR_FIELDS = {
  SINGLE_IMAGE: 'singleImage',
  MULTIPLE_IMAGES: 'multipleImages',
  YOUTUBE: 'youtube',
  INSTAGRAM: 'instagram',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  BUTTON: 'button',
};
 
export const SEO_DETAIL_FIELDS = {
  SEO_TITLE: 'title',
  SEO_SLUG: 'slug',
  SEO_DESCRIPTION: 'description',
  SEO_IMAGE: 'image',
  SEO_TAGS: 'tags',
};

export const PROJECT_MODULES_SLUGS = {
  STAFF_MANAGEMENT: 'staff-management',
  QR_CODE_MANAGER: 'qr-code-manager',
};

export const ENQUIRY_STATUS = {
  NEW: 'NEW',
  FOLLOW_UP: 'FOLLOW_UP',
  DECLINED: 'DECLINED',
  SPAM: 'SPAM',
  CLOSURE: 'CLOSURE',
  SHORTLIST: 'SHORTLIST',
  REJECT: 'REJECT',
  HIRED: 'HIRED',
};

export const QUOTATION_ENQUIRY_TYPES = {
  NEW_QUOTATION: 'NEW_QUOTATION',
  QUOTATION_CONFIRMED: 'QUOTATION_CONFIRMED',
};
export const APPOINTMENT_ENQUIRY_STATUS = {
  AWAITED: 'AWAITED',
  CONFIRMED: 'CONFIRMED',
  RESCHEDULED: 'RESCHEDULED',
  CANCELLED: 'CANCELLED',
  DONE: 'DONE',
};
export const STAFF_DESIGNATIONS = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  SENIOR_STAFF: 'SENIOR_STAFF',
  JUNIOR_STAFF: 'JUNIOR_STAFF',
};

export const ATTACHMENT_TYPES = {
  FILE: 'FILE',
  LINK: 'LINK',
};

export const ASSOCIATE_TYPES = {
  ASSOCIATE: 'ASSOCIATE',
  CLIENT: 'CLIENT',
  COLLABORATION: 'COLLABORATION',
};
export const JOB_TYPES = {
  FULL_TIME: 'FULL_TIME',
  PART_TIME: 'PART_TIME',
  ON_CONTRACT: 'ON_CONTRACT',
  INTERNSHIP: 'INTERNSHIP',
  FULL_TIME_ONLINE: 'FULL_TIME_ONLINE',
  PART_TIME_ONLINE: 'PART_TIME_ONLINE',
  FREELANCING_ONLINE: 'FREELANCING_ONLINE',
  ON_CONTRACT_ONLINE: 'ON_CONTRACT_ONLINE',
  INTERNSHIP_ONLINE: 'INTERNSHIP_ONLINE',
};
export const GENDERS = {
  ALL: 'ALL',
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
};
export const JOB_EXPERIENCE_LEVELS = [
  '0 - 6 months',
  '6 months - 1 year',
  '1 - 2 years',
  '2 - 5 years',
  '5 - 7 years',
  '7 - 10 years',
  '10 - 15 years',
  '15 - 20 years',
  '20 - 25 years',
  '25+ Years',
];
export const JOB_RATES = {
  PER_MONTH: 'PER_MONTH',
  PER_HOUR: 'PER_HOUR',
  PER_DAY: 'PER_DAY',
  PER_WEEK: 'PER_WEEK',
  ANNUAL: 'ANNUAL',
};

export const DATA_TYPES = {
  PLAIN_TEXT: 'PLAIN_TEXT',
  LONG_TEXT: 'LONG_TEXT',
  RICH_TEXT: 'RICH_TEXT',
  EMAIL: 'EMAIL',
  NUMBER: 'NUMBER',
  CURRENCY: 'CURRENCY',
  DROPDOWN: 'DROPDOWN',
  MULTI_SELECION_DROPDOWN: 'MULTI_SELECION_DROPDOWN',
  TOGGLE: 'TOGGLE',
  CHECKBOX: 'CHECKBOX',
  RADIO: 'RADIO',
  DATE: 'DATE',
  TIME: 'TIME',
  AVATAR_IMAGE: 'AVATAR_IMAGE',
  COVER_IMAGE: 'COVER_IMAGE',
  MULTIPLE_IMAGES: 'MULTIPLE_IMAGES',
  FILE: 'FILE',
  MULTIPLE_FILE: 'MULTIPLE_FILE',
  LINK: 'LINK',
  MULTI_LINK: 'MULTI_LINK',
  ARRAY: 'ARRAY',
  BUTTON: 'BUTTON',
  BLOG_EDITOR: 'BLOG_EDITOR',
  VARIENT_EDITOR: 'VARIENT_EDITOR',
  SEO_CONFIG: 'SEO_CONFIG',
  PASSWORD: 'PASSWORD',
  OBJECT_ID: 'OBJECT_ID',
  MULTI_OBJECT_ID: 'MULTI_OBJECT_ID',
  UNIQUE_ID: 'UNIQUE_ID',
  RELATION_COUNT: 'RELATION_COUNT',
  TAGS: 'TAGS',
};

export const DYNAMIC_FORM_DEFAULT_KEYS = {
  WEBSITE_PROJECT_ID: 'websiteProjectId',
  STATUS: 'status',
  PASSWORD: 'password',
  IS_DELETED: 'isDeleted',
  STAFF_FULL_NAME: 'fullName',
  STAFF_EMP_ID: 'employeeId',
  STAFF_LOGIN_MOBILE_NUMBER: 'mobileNumber',
  STAFF_LOGIN_EMAIL: 'email',
  STAFF_DESIGNATION: 'designation',
  STAFF_LOGIN_RIGHT: 'isStaffAllowedLogin',
  STAFF_ASSIGNED_MODULES: 'modules',
  // object keys under staff modules array[]
  //-----------------------------------------------------------------------------
  STAFF_ASSIGNED_MODULES_MODULE_ID: 'module', // object id from module management
  STAFF_ASSIGNED_MODULES_MODULE_RIGHTS: 'rights',
  //-----------------------------------------------------------------------------
};

export const SECTION_TYPES = {
  MAIN: 'MAIN',
  SIDE: 'SIDE',
};

export const CREATE_PASSWORD_FIELD = 'createPassword';

export const PRODUCT_DEFAULT_VARIANTONE_FIELD = 'variants.variantOne';
export const PRODUCT_DEFAULT_VARIANTTWO_FIELD = 'variants.variantTwo';
export const PRODUCT_DEFAULT_VARIANTTHREE_FIELD = 'variants.variantThree';

export const DEFAULT_COUNTRY = 'INDIA';
